module.exports = __webpack_public_path__ + "img/core-business.275efcea.jpg";